import styled from "styled-components";

interface ContainerProps {
  top: number;
  left: number;
}

export const ContainerModalStatusErro = styled.div<ContainerProps>`
  position: fixed;
  top: ${({ top }) => top}px;
  left: ${({ left }) => left}px;
  transform: translateX(calc(-100% - 8px));
  z-index: 9999;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 12px 14px;
  min-width: 350px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15);
  pointer-events: none;
`;

export const ModalInfoRow = styled.div`
  background-color: ${({ theme }) => theme.colors.neutral.neutral05};
  padding: 12px;
  display: flex;
  gap: 24px;
  margin-bottom: 10px;
`;

export const ModalInfoItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;

  small {
    font-size: 11px;
    color: #888;
  }

  span {
    font-size: 14px;
    font-weight: 500;
    color: #333;
  }
`;

export const ModalErroTitulo = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 4px;
  font-weight: 600;
`;

export const ContainerIcone = styled.span`
  color: #dc3545;
`;

export const ModalErroMensagem = styled.p`
  font-size: 14px;
  color: #555;
  margin: 0;
  line-height: 1.4;
`;
